/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */
import { HttpClient } from "../../apiCalls/httpClient";
import { formatHTS } from "../util";
import { getCheckDigitAndSaveEntryNumber } from "../actions";

export const getHTSData = (code) => {
  const data = {
    eventMessage: {
      country: "CA",
      hsCodeRoot: formatHTS(code),
      hsVersion: "2019Rev2.0",
    },
    eventType: "GET_HTS_TREE",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getHSDetail = (payload) => {
  const data = {
    eventMessage: {
      htsCode: payload.hts,
      country: "CA",
      eta: window.shipmentETA,
    },
    eventType: "GET_HTS_METADATA",
    eventTime: Date.now(),
  };
  if (payload.tariffTreatments) {
    data.eventMessage.tariffTreatments = payload.tariffTreatments;
  }
  return HttpClient.custom({
    data,
  });
};

export const getHSDtlList = (htsArray) => {
  const data = {
    eventMessage: {
      htsCode: htsArray[0],
      eta: window.shipmentETA,
    },
    eventType: "GET_CBSA_PGA_FOR_HTS_CODE",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};
export const getPgaMetaDeta = (cbsaPgaType, cbsaPgaSubProgramType) => {
  const data = {
    eventMessage: {
      level: 2,
      pgas: [
        {
          cbsaPgaType,
          cbsaPgaSubProgramType,
        },
      ],
    },
    eventType: "GET_CBSA_PGA_METADATA",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};
export const getHSDtlListforUoM = (hts) => {
  const data = {
    eventMessage: {
      htsCode: hts,
      eta: window.shipmentETA,
    },
    eventType: "GET_CBSA_PGA_FOR_HTS_CODE",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};
export const getExciseRequirements = (hts) => {
  const data = {
    eventMessage: {
      hsCode: hts,
    },
    eventType: "GET_CBSA_EXCISE_REQUIREMENTS",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};
export const getPgaforhtsCode = (hts) => {
  const data = {
    eventMessage: {
      htsCode: hts,
      eta: window.shipmentETA,
    },
    eventType: "GET_CBSA_PGA_FOR_HTS_CODE",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getHSDtl = (hts) => {
  const data = {
    eventMessage: {
      hsCodeRoot: hts,
      country: "US",
      hsVersion: "2019Rev2.0",
    },
    eventType: "GET_HS_DTL_HS",
    eventTime: Date.now(),
  };
  console.log("GET_HS_DTL_HS", data);
  return HttpClient.custom({
    data,
  });
};

export const getHSpgaDetail = (payload) => {
  const data = {
    eventMessage: {
      htsCode: payload.hts,
      pgas: [
        {
          cbsaPgaType: payload.cbsaPgaType,
          cbsaPgaSubProgramType: payload.cbsaPgaSubProgramType,
        },
      ],
    },
    eventType: "GET_CBSA_PGA_METADATA",
    eventTime: Date.now(),
  };
  if (payload.tariffTreatment) {
    data.eventMessage.tariffTreatment = payload.tariffTreatment;
  }
  return HttpClient.custom({
    data,
  });
};

export const getTHSpga = (payload) => {
  const data = {
    eventMessage: {
      htsCode: payload.hts,
      eta: window.shipmentETA,
    },
    eventType: "GET_CBSA_PGA_FOR_HTS_CODE",
    eventTime: Date.now(),
  };
  if (payload.tariffTreatment) {
    data.eventMessage.tariffTreatment = payload.tariffTreatment;
  }
  return HttpClient.custom({
    data,
  });
};
